import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useParams } from "react-router-dom";
import axios from "axios";
import { withFirebase } from "../../firebase";
import { useTranslation } from "react-i18next";
import { updateShops } from "../../reducers/shops";
import {
	Paper,
	Typography,
	Collapse,
	IconButton,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
} from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { WorkingHoursTable } from "./table";

export const WorkTimeContainer = (props) => {
	const { city } = useParams();
	const { firebase } = props;
	const shops = useSelector((state) => state.shops.shops);
	const dispatch = useDispatch();

	const activeBrand = shops
		?.flatMap((shop) => shop.brands)
		.find((brand) => brand.id == city);

	const deliveryTerminals = activeBrand?.deliveryTerminals || [];

	const [openIndex, setOpenIndex] = useState(0); // какой терминал открыт

	const cityIndex = localStorage.getItem("chosenCity");
	const brand = localStorage.getItem("chosenBrand");
	const isDebug = JSON.parse(localStorage.getItem("isDebug"));

	const handleToggle = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	const [terminals, setTerminals] = useState([]);

	useEffect(() => {
		if (activeBrand?.deliveryTerminals) {
			// Копируем данные, чтобы не мутировать Redux
			setTerminals(
				activeBrand.deliveryTerminals.map((t) => ({
					...t,
					workingHours: t.workingHours || [],
				}))
			);
		}
	}, [activeBrand]);

	const handleSave = (index, updatedWorkingHours) => {
		const updatedTerminals = terminals.map((t, i) =>
			i === index ? { ...t, workingHours: updatedWorkingHours } : t
		);
		setTerminals(updatedTerminals);

		const daliveryTerminalsData = updatedTerminals;

		firebase.bd
			.ref(
				`${isDebug ? "debug" : ""}/settings/city/${cityIndex}/brands/${brand}`
			)
			.once("value")
			.then((snapshot) => {
				const brandData = snapshot.val() || {};
				const updatedBrandData = {
					...brandData,
					deliveryTerminals: daliveryTerminalsData,
				};

				return firebase.bd
					.ref(
						`${
							isDebug ? "debug" : ""
						}/settings/city/${cityIndex}/brands/${brand}`
					)
					.set(updatedBrandData);
			})
			.then(() => {
				const updatedCities = shops.map((c, ind) => {
					console.log(c.id, cityIndex);
					if (c.ind !== cityIndex) return c;

					const updatedBrands = c.brands.map((b, indBrand) => {
						if (b.indBrand !== brand) return b;

						return { ...b, deliveryTerminals: daliveryTerminalsData };
					});

					return { ...c, brands: updatedBrands };
				});

				dispatch(updateShops(updatedCities));
				alert("Збережено");
			})
			.catch((err) => console.error(err));
	};

	// const updateStatusApp = () => {
	// 	firebase.bd
	// 		.ref(
	// 			`${
	// 				JSON.parse(localStorage.getItem("isDebug")) ? "debug" : ""
	// 			}/settings/city/${cityIndex}/brands/${brand}/checkoutScreen`
	// 		)
	// 		.update({ deliveryTerminals: !statusPayment })
	// 		.then(() => {
	// 			getStatus();
	// 		})
	// 		.catch((error) => {
	// 			console.error("Failed to update statusPayment:", error);
	// 		});
	// };

	return (
		<div>
			<List>
				{terminals.map((terminal, index) => (
					<div key={terminal.id}>
						<ListItem button onClick={() => handleToggle(index)}>
							<ListItemText primary={terminal.name} />
							<ListItemSecondaryAction>
								<IconButton edge="end" onClick={() => handleToggle(index)}>
									{openIndex === index ? <ExpandLess /> : <ExpandMore />}
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>

						<Collapse in={openIndex === index} timeout="auto" unmountOnExit>
							<Paper style={{ margin: "0 16px 16px", padding: 16 }}>
								<WorkingHoursTable
									initialData={terminal.workingHours}
									onSave={(data) => handleSave(index, data)}
								/>
							</Paper>
						</Collapse>
					</div>
				))}
			</List>
		</div>
	);
};

export default withFirebase(withRouter(WorkTimeContainer));
